import type { SVGProps } from 'react'

/**
 * THIS FILE IS AUTO GENERATED!
 * Direct changes to this file will be overwritten on next icons:build execution.
 * Changes have to be made in the assets/*.svg file.
 * Afterwards execute the icons:build command.
 */
export const DocumentDownload = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={32}
    height={32}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6 20v6h20v-6"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="square"
    />
    <path
      d="M16 21V5m0 16l6-6.171M16 21l-6-6.171"
      stroke="currentColor"
      strokeWidth={2}
    />
  </svg>
)
